import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["critical-speed-without-a-lab"]!;

export function Body() {
  return (
    <>
      <p>
        Critical speed is one of the most useful numbers in running. It marks roughly the
        fastest pace you can hold before fatigue starts to build up steadily. Do you need a lab
        to find it? Several studies say no.
      </p>

      <h2>Why critical speed matters</h2>
      <p>
        In a study of ten well-trained runners, oxygen uptake stayed stable just below critical
        speed but kept rising just above it. The researchers concluded that critical speed marks
        the upper limit of what the body can sustain in a steady state better than a common
        lactate-based threshold.
      </p>

      <h2>What the researchers did</h2>
      <p>
        One group of researchers used the training logs of more than 25,000 recreational
        runners. From each runner's fastest efforts over several distances, they calculated
        critical speed without any extra testing.
      </p>
      <p>
        Another group asked 23 recreational runners to wear a foot pod for eight weeks. They
        compared critical speed calculated from six weeks of normal training with results from
        three maximal time trials of 3, 7 and 12 minutes, and with 3-minute all-out tests.
      </p>

      <h2>What they found</h2>
      <p>
        In the large study, critical speed calculated from training data was linked to marathon
        performance and helped explain who slowed down late in the race.
      </p>
      <p>
        In the smaller study, the different methods gave similar values for critical speed, and
        repeated tests gave very consistent results. The estimate of how much work can be done
        above critical speed was much less consistent between methods.
      </p>

      <h2>What it means for you</h2>
      <p>
        If you run hard efforts of different lengths now and then, your training already
        contains much of the information needed to estimate critical speed. A few maximal time
        trials on separate, well-rested days can make the estimate more precise. The researchers
        allowed at least 24 hours between efforts and recommended 48.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        Training data only works if some runs are truly hard efforts. An estimate is not the same
        as a lab measurement, and for the individual runner the methods can still differ.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training builds your targets from your own races, tests and runs. A maximal test is
        only suggested when it suits you, and you don't need a lab.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Nixon et al. (2021), Steady-state VO₂ above MLSS: evidence that critical speed better
          represents maximal metabolic steady state in well-trained runners.{" "}
          <a href="https://doi.org/10.1007/s00421-021-04780-8">European Journal of Applied Physiology</a>.
        </li>
        <li>
          Smyth & Muniz-Pumares (2020), Calculation of critical speed from raw training data in
          recreational marathon runners.{" "}
          <a href="https://doi.org/10.1249/MSS.0000000000002412">Medicine & Science in Sports & Exercise</a>.
        </li>
        <li>
          Hunter, Ledger & Muniz-Pumares (2023), Remote determination of critical speed and
          critical power in recreational runners.{" "}
          <a href="https://doi.org/10.1123/ijspp.2023-0276">International Journal of Sports Physiology and Performance</a>.
        </li>
      </ul>
    </>
  );
}
